const custMenu = {
	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		hint: [],
		children: {
			ZZ1: {
				name: ['出勤', 'Attendance hours', '出勤'],
				children: {
					ZZ_COMMON_AM10010: {
						name: ['出勤模擬試算', 'Attendance Simulation', '出勤模拟试算'],
						url: '/zz_common_am10010',
						hint: [],
					},
				},
			},
			ZZ_35882520: {
				name: [`傳票`, `Accountting`, `传票`],
				children: {
						ZZ_COMMON_PB10030: {
								name: ['傳票設定', 'Accountting Settings', '传票设定'],
								url: '/zz_common_pb10030',
								hint: [],
						},
						ZZ_COMMON_PB10031: {
							name: ['傳票匯出', 'Accountting Export', '传票汇出'],
							url: '/zz_common_pb10031',
							hint: [],
					},
				},
		},
		},
	},
};

module.exports = (paidMenu) => {
	return { ...paidMenu, ...custMenu };
};